/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Container, Stack, TextField, Tooltip, Typography,
  CardMedia, Grid, IconButton, Box, FormControl, Button
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Page from '../../../../Page';
import { AESDecryptionParam } from '../../../../../helpers/AesEncrypt';
import services from '../../Service';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import Card from '@material-ui/core/Card';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { Document } from './Document';
import InputAdornment from '@material-ui/core/InputAdornment';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import InputLabel from '@material-ui/core/InputLabel';
import { PhoneNumberUtil } from 'google-libphonenumber';
import SearchIcon from '@material-ui/icons/Search';

var screenCode = "FARMER"

export function FarmerAddEdit({ setFarmerID, handleNext, setFarmerCollectionCenterID }) {
  const navigate = useNavigate();
  const params = useParams();
  let decrypted = 0;
  let decrypted1 = 0;
  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [DocumentData, setDocumentData] = useState([]);
  const [documentCount, setDocumentCount] = useState(0);
  const [cityList, setCityList] = useState([]);
  const [gnDivisionList, setGnDivisionList] = useState([]);
  const [dsDivisionList, setDsDivisionList] = useState([]);
  const [groupFactory, setGroupFactory] = useState([]);
  const [festival, setFestivalName] = useState([]);
  const [otherFestival, setOtherFestival] = useState(false);
  const [language, setLanguageName] = useState([]);
  const [FestivalList, setFestivalList] = useState([]);
  const [LanguageList, setLanguageList] = useState([]);
  const [OwnershipOfFarmingLandTypeList, setOwnershipOfFarmingLandTypeList] = useState([]);
  const [OwnershipOfFarmingLandList, setOwnershipOfFarmingLandList] = useState([]);
  const [factoryType, setFactoryType] = useState(0);
  const [ImageObject, setImageObject] = useState();
  const [IsDefault, setIsDefault] = useState(1);
  const phoneNumberUtil = PhoneNumberUtil.getInstance();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const today = new Date().toISOString().split('T')[0];
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isDormentoFilterEnabled: false
  });
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    nicEdit: true,
    isEditType: 1,
    submitButtonName: "Save",
    pageheadername: "Save Personal Details"
  });

  const [formData, setFormData] = useState({
    farmerID: 0,
    groupID: 0,
    collectionCenterID: 0,
    givenName: "",
    firstName: "",
    middleName: "",
    lastName: "",
    nic: "",
    joiningDate: today,
    gender: 0,
    regNumber: "",
    navisionNumber: "",
    province: 0,
    district: 0,
    city: 0,
    address1: "",
    address2: "",
    address3: "",
    farmerMobile: "",
    landMobile: "",
    supplyLocation: "",
    distance: "",
    dob: today,
    nationality: 0,
    maritalStatus: 0,
    education: 0,
    email: "",
    isActive: true,
    farmerTypeID: 1,
    secondaryMobile: "",
    numberofChildren: 0,
    repayingaloan: 2,
    sarubimareception: 2,
    ownershipOfFarmingLandID: 0,
    seasonalFarmer: 0,
    acknowledgement: true,
    acknowledgementOne: true,
    acknowledgementTwo: true,
    extentID: 0,
    extentValue: "",
    modeOfOperation: 2,
    titleID: 0,
    otherTitle: "",
    businessName: "",
    brNumber: "",
    otherEducation: "",
    gnDivisionID: 0,
    dsDivisionID: 0,
    otherFestivalsCelebrated: "",
    isDormant: true
  });

  const ProductSaveSchema = Yup.object().shape({
    givenName: Yup.string()
      .when('modeOfOperation', {
        is: (modeOfOperation) => (modeOfOperation == 1 || modeOfOperation == 2),
        then: Yup.string()
          .required('Preferred Name required')
          .matches(/^[a-zA-Z\.][a-zA-Z\s\.]*$/, "Only alphabets are allowed for this field"),
        otherwise: Yup.string().nullable(),
      }),

    firstName: Yup.string().notRequired(),
    middleName: Yup.string()
      .when('modeOfOperation', {
        is: (modeOfOperation) => modeOfOperation != 1,
        then: Yup.string()
          .matches(/^[aA-zZ\s\.]+$/, "Only alphabets are allowed for this field")
          .required('Full Name required'),
        otherwise: Yup.string().nullable(),
      }),

    modeOfOperation: Yup.number().min(1, 'Mode of Operation is Required').required('Mode of Operation is Required'),
    nic: Yup.string()
      .when('modeOfOperation', {
        is: (modeOfOperation) => modeOfOperation == 1,
        then: Yup.string().required('BR Number is Required'),
        otherwise: Yup.string().required('NIC required').matches(/^(\d{9}[VX]|\d{12})$/, 'Please enter valid NIC with capital letter'),
      }),
    businessName: Yup.string()
      .when('modeOfOperation', {
        is: (modeOfOperation) => modeOfOperation == 1,
        then: Yup.string()
          .required('Business Name is Required'),
        otherwise: Yup.string().nullable(),
      }),
    joiningDate: Yup.string().required('Date of Registration required'),
    regNumber: Yup.string().notRequired(),
    navisionNumber: Yup.string().notRequired(),
    province: Yup.string().notRequired(),
    district: Yup.string().notRequired(),
    city: Yup.string().notRequired(),
    address1: Yup.string().required('Address Line 1 is required'),
    address2: Yup.string().required('Address Line 2 is required'),
    address3: Yup.string().nullable(true),
    farmerMobile: Yup
      .string()
      .test('phone-number', 'Invalid phone number', (value) =>
        validatePhoneNumber(value)
      ),
    distance: Yup.string().matches(/^\d+(\.\d{1,2})?$/, 'Distance must be a number with up to 2 decimal places').nullable(true),
    dob: Yup.string()
      .when('modeOfOperation', {
        is: (modeOfOperation) => modeOfOperation == 2,
        then: Yup.string()
          .required('Date of Birth required'),
        otherwise: Yup.string().nullable(),
      }),
    nationality: Yup.number().nullable(true),
    maritalStatus: Yup.number().nullable(true),
    education: Yup.string().nullable(true),
    email: Yup.string().nullable(true).matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g, 'Not a valid E-Mail Address'),
    farmerTypeID: Yup.number().min(1, 'Supplier Type Required').required('Supplier Type required'),
    extentValue: Yup.string()
      .when('extentID', {
        is: (extentID) => extentID !== 0,
        then: Yup.string()
          .required('Extent Value Is Required')
          .matches(/^\d+(\.\d{1,2})?$/, 'Extent Value must be a number with up to 2 decimal places'),
        otherwise: Yup.string().nullable(),
      }),
    seasonalFarmer: Yup.number().min(1, 'Seasonal Supplier is Required').required('Seasonal Supplier is Required'),
    province: Yup.number().min(1, 'Provice is Required').required('Provice is Required'),
    district: Yup.number().min(1, 'District is Required').required('District is Required'),
    city: Yup.number().min(1, 'City is Required').required('City is Required'),
    dsDivisionID: Yup.number().min(1, 'DS Division is Required').required('DS Division is Required'),
    gnDivisionID: Yup.number().min(1, 'GN Division is Required').required('GN Division is Required'),
    gender: Yup.number()
      .when('modeOfOperation', {
        is: (modeOfOperation) => modeOfOperation != 1,
        then: Yup.number()
          .min(1, 'Gender is Required')
          .required('Gender is Required'),
        otherwise: Yup.number().nullable(),
      }),
    maritalStatus: Yup.number()
      .when('modeOfOperation', {
        is: (modeOfOperation) => modeOfOperation != 1,
        then: Yup.number()
          .min(1, 'Marital Status is Required')
          .required('Marital Status is Required'),
        otherwise: Yup.number().nullable(),
      }),

    education: Yup.number()
      .when('modeOfOperation', {
        is: (modeOfOperation) => modeOfOperation != 1,
        then: Yup.number()
          .min(1, 'Education Type is Required')
          .required('Education Type is Required'),
        otherwise: Yup.number().nullable(),
      }),

    titleID: Yup.number()
      .when('modeOfOperation', {
        is: (modeOfOperation) => modeOfOperation != 1,
        then: Yup.number().min(1, 'Title is Required').required('Title is Required'),
        otherwise: Yup.number().nullable(),
      }),

    otherTitle: Yup.string()
      .when('titleID', {
        is: (titleID) => titleID == 5,
        then: Yup.string()
          .required('Other Title is Required'),
        otherwise: Yup.string().nullable(),
      }),
    otherEducation: Yup.string()
      .when('education', {
        is: (education) => education == 10,
        then: Yup.string()
          .required('Other Highest Level of Education is Required'),
        otherwise: Yup.string().nullable(),
      }),
    otherFestivalsCelebrated: otherFestival == false ? Yup.string().nullable() : Yup.string().required('Other Festivals Celebrated is Required')
  });

  const formik = useFormik({
    initialValues: {
      farmerID: formData.farmerID,
      groupID: groupFactory.groupID,
      givenName: formData.givenName,
      firstName: formData.firstName,
      middleName: formData.middleName,
      lastName: formData.lastName,
      nic: formData.nic,
      collectionCenterID: formData.collectionCenterID,
      joiningDate: formData.joiningDate,
      gender: formData.gender,
      regNumber: formData.regNumber,
      navisionNumber: formData.navisionNumber,
      province: formData.province,
      district: formData.district,
      city: formData.city,
      address1: formData.address1,
      address2: formData.address2,
      address3: formData.address3,
      farmerMobile: formData.farmerMobile,
      landMobile: formData.landMobile,
      supplyLocation: formData.supplyLocation,
      nationality: formData.nationality,
      distance: formData.distance,
      dob: formData.dob,
      nationality: formData.nationality,
      maritalStatus: formData.maritalStatus,
      education: formData.education,
      email: formData.email,
      isActive: formData.isActive,
      image: formData.image,
      farmerTypeID: formData.farmerTypeID,
      secondaryMobile: formData.secondaryMobile,
      numberofChildren: formData.numberofChildren,
      repayingaloan: formData.repayingaloan,
      sarubimareception: formData.sarubimareception,
      ownershipOfFarmingLandID: formData.ownershipOfFarmingLandID,
      seasonalFarmer: formData.seasonalFarmer,
      acknowledgement: formData.acknowledgement,
      acknowledgementOne: formData.acknowledgementOne,
      acknowledgementTwo: formData.acknowledgementTwo,
      extentID: formData.extentID,
      extentValue: formData.extentValue,
      modeOfOperation: formData.modeOfOperation,
      titleID: formData.titleID,
      otherTitle: formData.otherTitle,
      businessName: formData.businessName,
      brNumber: formData.brNumber,
      otherEducation: formData.otherEducation,
      dsDivisionID: formData.dsDivisionID,
      gnDivisionID: formData.gnDivisionID,
      otherFestivalsCelebrated: formData.otherFestivalsCelebrated,
      isDormant: formData.isDormant
    },
    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {
      if (pageProps.isEditType == 2) {
        UpdateFarmer(values, pageProps.editingID);
      }
      else if (pageProps.isEditType == 1) {
        SaveFarmer(values);
      }
      else {
        AssignFarmer(values, pageProps.editingID);
      }
    },
    enableReinitialize: true

  });

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;
  useEffect(() => {
    (getPermissions());
    trackPromise(getAllFestivalTypes());
    trackPromise(GetAllOwnershipOfFarmingLandTypes());
    trackPromise(getAllFarmerLanguageTypes());
    (getProvinceForDropdown());
  }, []);

  useEffect(() => {
    if (pageProps.isEditType == 1) {
      (GetOperationEntityByGroupID());
    }
  }, [groupFactory.groupID]);

  useEffect(() => {
    (getDistrictForDropdown());
  }, [formik.values.province]);

  useEffect(() => {
    (getCityForDropdown());
  }, [formik.values.province, formik.values.district]);

  useEffect(() => {
    (getDsDivisionsForDropdown());
  }, [formik.values.province, formik.values.district, formik.values.city]);

  useEffect(() => {
    (getGnDivisionsForDropdown());
  }, [formik.values.province, formik.values.district, formik.values.city, formik.values.dsDivisionID]);

  useEffect(() => {
    var found = festival.find(x => x == 'Other')
    setOtherFestival(found == undefined ? false : true);
  }, [festival]);

  useEffect(() => {
    decrypted = AESDecryptionParam(params.farmerID.toString());
    decrypted1 = AESDecryptionParam(params.farmerCollectionCenterID.toString());
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEditType: 2,
        nicEdit: false,
        submitButtonName: "Update",
        pageheadername: "Update Personal Details",
        editingID: parseInt(decrypted)
      })
      setFarmerID(parseInt(decrypted))
      setFarmerCollectionCenterID(parseInt(decrypted1))
      trackPromise(GetFarmerByFarmerID(decrypted));
      GetCollectionCenterByFarmerCollectionCenterID(decrypted1, decrypted);
    }
  }, []);

  useEffect(() => {
    if (formik.values.modeOfOperation === 1 && pageProps.isEditType === 1) {
      setValues({
        ...values,
        firstName: '',
        middleName: '',
        lastName: "",
        givenName: "",
        joiningDate: new Date().toISOString().split('T')[0],
        gender: 0,
        regNumber: "",
        dob: new Date().toISOString().split('T')[0],
        distance: "",
        nationality: 0,
        maritalStatus: 0,
        education: 0,
        businessName: "",
        brNumber: "",
        otherEducation: "",
        navisionNumber: "",
        otherFestivalsCelebrated: "",
        titleID: 0,
        otherTitle: "",
      })
      setLanguageName([]);
      setFestivalName([]);
    }
  }, [formik.values.modeOfOperation]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMER');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isDormentoFilterEnabled = permissions.find(p => p.permissionCode == 'DORMENTBUTTON');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isDormentoFilterEnabled: isDormentoFilterEnabled !== undefined
    });

    setGroupFactory({
      ...groupFactory,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
    setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
  }

  async function SaveFarmer(value) {
    if ((formik.values.acknowledgement == true) && (formik.values.acknowledgementOne != true && formik.values.acknowledgementTwo != true)) {
      toast.error("One acknowledgement or must be select");
      return;
    }
    let farmerFestival = [];
    festival.forEach(x => {
      const idlist = FestivalList.find(y => y.festival == x)
      let model = {
        festivalTypeID: idlist.festivalTypeID
      };
      farmerFestival.push(model);
    });

    let ownershipOfFarmingLand = [];
    OwnershipOfFarmingLandList.forEach(x => {
      const idlist = OwnershipOfFarmingLandTypeList.find(y => y.ownershipOfFarmingLandTypeName == x)
      let model = {
        ownershipOfFarmingLandTypeID: idlist.ownershipOfFarmingLandTypeID
      };
      ownershipOfFarmingLand.push(model);
    });
    let languageLen = [];
    language.forEach(x => {
      const idlist = LanguageList.find(y => y.farmerLanguageTypeName == x)
      let model = {
        farmerLanguageTypeID: idlist.farmerLanguageTypeID
      };
      languageLen.push(model);
    });
    if (documentCount == 0) {
      toast.error("One or more Farmer Document should be added");
      return;
    }
    if (languageLen.length === 0 && formik.values.modeOfOperation != 1) {
      toast.error("Languages should be add");
      return;
    }
    var res = await services.SaveFarmer(value, DocumentData, farmerFestival, ownershipOfFarmingLand, languageLen, otherFestival);
    if (res.statusCode === "Success") {
      toast.success("Farmer Saved Succesfully");
      setTimeout(() => {
        setFarmerID(res.data)
        handleNext();
      }, 1000);
    } else {
      toast.error(res.message);
    }
  }

  async function UpdateFarmer(values, decrypted) {

    if ((formik.values.acknowledgement === true) && (formik.values.acknowledgementOne !== true && formik.values.acknowledgementTwo !== true)) {
      toast.error("One acknowledgement must be selected");
      return;
    }

    let farmerFestival = [];
    festival.forEach(x => {
      const idlist = FestivalList.find(y => y.festival === x);
      let model = {
        festivalTypeID: idlist.festivalTypeID
      };
      farmerFestival.push(model);
    });

    let ownershipOfFarmingLand = [];
    OwnershipOfFarmingLandList.forEach(x => {
      const idlist = OwnershipOfFarmingLandTypeList.find(y => y.ownershipOfFarmingLandTypeName === x);
      let model = {
        ownershipOfFarmingLandTypeID: idlist.ownershipOfFarmingLandTypeID
      };
      ownershipOfFarmingLand.push(model);
    });

    let languageLen = [];
    if (formik.values.modeOfOperation !== 1) {
      language.forEach(x => {
        const idlist = LanguageList.find(y => y.farmerLanguageTypeName === x);
        let model = {
          farmerLanguageTypeID: idlist.farmerLanguageTypeID
        };
        languageLen.push(model);
      });
    } else {
      languageLen = []; 1
    }

    if (documentCount === 0) {
      toast.error("One or more Farmer Document should be added");
      return;
    }

    if (languageLen.length === 0 && formik.values.modeOfOperation !== 1) {
      toast.error("Languages should be added");
      return;
    }

    var res = await services.UpdateFarmer(values, decrypted, farmerFestival, ownershipOfFarmingLand, languageLen, otherFestival);
    if (res.statusCode === "Success") {
      toast.success("Farmer Updated Successfully");
      setTimeout(() => {
        navigate('/dashboard/farmer');
      }, 1000);
    } else {
      toast.error(res.message);
    }
  }

  async function AssignFarmer(values, decrypted) {
    var res = await services.AssignFarmer(values, decrypted);
    if (res.statusCode === "Success") {
      toast.success(res.message);
      setTimeout(() => {
        navigate('/dashboard/farmer');
      }, 3000);
    } else {
      toast.error(res.message);
    }
  }

  async function GetFarmerDetailsByNIC() {
    if (formik.values.nic != '' || formik.values.nic != undefined) {
      if (pageProps.isEditType == 1 || pageProps.nicEdit == true) {
        var res = await services.GetFarmerDetailsByNIC(formik.values.nic);
        if (res.length > 0) {
          setFormData((prevState) => ({
            ...prevState,
            farmerID: res[0].farmerID,
            groupID: res[0].groupID,
            collectionCenterID: res[0].collectionCenterID,
            givenName: res[0].givenName == null ? "" : res[0].givenName,
            firstName: res[0].firstName == null ? "" : res[0].firstName,
            middleName: res[0].middleName == null ? "" : res[0].middleName,
            lastName: res[0].lastName == null ? "" : res[0].lastName,
            nic: res[0].nic,
            joiningDate: res[0].joingDate == null ? "" : res[0].joingDate.split('T')[0],
            gender: res[0].gender,
            regNumber: res[0].registrationNumber,
            navisionNumber: res[0].navisionNumber == null ? "" : res[0].navisionNumber,
            province: res[0].province,
            district: res[0].district,
            city: res[0].city,
            address1: res[0].address1,
            address2: res[0].address2 == null ? "" : res[0].address2,
            address3: res[0].address3 == null ? "" : res[0].address3,
            farmerMobile: res[0].mobileNumber,
            landMobile: res[0].landNumber == null ? "" : res[0].landNumber,
            distance: res[0].distance == null ? "" : res[0].distance,
            dob: res[0].dob == null ? "" : res[0].dob.split('T')[0],
            nationality: res[0].nationality,
            maritalStatus: res[0].maritalStatus,
            education: res[0].education == null ? 0 : parseInt(res[0].education),
            email: res[0].email == null ? "" : res[0].email,
            isActive: res[0].isActive,
            farmerTypeID: res[0].farmerTypeID == 0 ? 1 : res[0].farmerTypeID,
            secondaryMobile: res[0].secondaryMobile == null ? "" : res[0].secondaryMobile,
            numberofChildren: res[0].numberofChildren,
            repayingaloan: res[0].repayingaloan,
            sarubimareception: res[0].sarubimareception,
            extentID: res[0].extentID,
            extentValue: res[0].extentValue == null ? "" : res[0].extentValue,
            ownershipOfFarmingLandID: res[0].ownershipOfFarmingLandID,
            seasonalFarmer: res[0].seasonalFarmer,
            acknowledgementOne: true,
            acknowledgementTwo: true,
            acknowledgement: true,
            modeOfOperation: res[0].modeOfOperation == 0 ? 2 : res[0].modeOfOperation,
            titleID: res[0].titleID,
            otherTitle: res[0].otherTitle == null ? "" : res[0].otherTitle,
            businessName: res[0].businessName == null ? "" : res[0].businessName,
            brNumber: res[0].brNumber == null ? "" : res[0].brNumber,
            otherEducation: res[0].otherEducation == null ? "" : res[0].otherEducation,
            dsDivisionID: res[0].dsDivisionID,
            gnDivisionID: res[0].gnDivisionID,
            otherFestivalsCelebrated: res[0].otherFestivalsCelebrated == null ? "" : res[0].otherFestivalsCelebrated
          }));
          setImageObject(res[0].imageURL)
          GetFarmerFestivalByFarmerID(res[0].farmerID);
          GetOwnershipOfFarmingLandByFarmerID(res[0].farmerID);
          GetFarmerLanguageByFarmerID(res[0].farmerID);
          const Default = res.find(x => parseInt(x.collectionCenterID) === parseInt(TokenDecoder.getGroupFactoryToken().factory));
          if (Default == undefined) {
            setPageProps({
              ...pageProps,
              isEditType: 3,
              nicEdit: true,
              submitButtonName: "Assign",
              pageheadername: "Assign Personal Details",
              editingID: parseInt(res[0].farmerID)
            })
            setFarmerID(parseInt(res[0].farmerID))
          }
          else {
            setPageProps({
              ...pageProps,
              isEditType: 2,
              nicEdit: true,
              submitButtonName: "Update",
              pageheadername: "Update Personal Details",
              editingID: parseInt(res[0].farmerID)
            })
            setFarmerID(parseInt(res[0].farmerID))
          }
        }
        else {
          setFormData((prevState) => ({
            ...prevState,
            farmerID: 0,
            groupID: 0,
            collectionCenterID: 0,
            givenName: "",
            firstName: "",
            middleName: "",
            lastName: "",
            joiningDate: new Date().toISOString().split('T')[0],
            gender: 0,
            regNumber: "",
            navisionNumber: "",
            province: 0,
            district: 0,
            city: 0,
            address1: "",
            address2: "",
            address3: "",
            farmerMobile: "",
            landMobile: "",
            dob: new Date().toISOString().split('T')[0],
            distance: "",
            nationality: 0,
            maritalStatus: 0,
            education: "",
            email: "",
            isActive: true,
            farmerTypeID: 1,
            secondaryMobile: "",
            numberofChildren: 0,
            repayingaloan: 2,
            sarubimareception: 2,
            ownershipOfFarmingLandID: 0,
            seasonalFarmer: 0,
            acknowledgement: true,
            acknowledgementOne: true,
            acknowledgementTwo: true,
            extentID: 0,
            extentValue: "",
            modeOfOperation: 2,
            titleID: 0,
            otherTitle: "",
            businessName: "",
            brNumber: "",
            otherEducation: "",
            dsDivisionID: 0,
            gnDivisionID: 0,
            otherFestivalsCelebrated: ""
          }));
          setImageObject(null);
          setPageProps({
            ...pageProps,
            isEditType: 1,
            nicEdit: true,
            submitButtonName: "Save",
            pageheadername: "Save Personal Details",
            editingID: parseInt(0)
          })
          setFarmerID(parseInt(0))
        }
      }
    }
  }

  async function GetFarmerByFarmerID(decrypted) {
    var res = await services.GetFarmerByFarmerID(decrypted);
    if (res.statusCode == "Success") {
      setFormData((prevState) => ({
        ...prevState,
        groupID: res.data.groupID,
        operationEntityID: res.data.operationEntityID,
        collectionCenterID: res.data.collectionCenterID,
        givenName: res.data.givenName == null ? "" : res.data.givenName,
        firstName: res.data.firstName == null ? "" : res.data.firstName,
        middleName: res.data.middleName == null ? "" : res.data.middleName,
        lastName: res.data.lastName == null ? "" : res.data.lastName,
        nic: res.data.nic,
        joiningDate: res.data.joingDate == null ? "" : res.data.joingDate.split('T')[0],
        gender: res.data.gender,
        regNumber: res.data.registrationNumber,
        navisionNumber: res.data.navisionNumber == null ? "" : res.data.navisionNumber,
        province: res.data.province,
        district: res.data.district,
        city: res.data.city,
        address1: res.data.address1,
        address2: res.data.address2 == null ? "" : res.data.address2,
        address3: res.data.address3 == null ? "" : res.data.address3,
        farmerMobile: res.data.mobileNumber,
        landMobile: res.data.landNumber == null ? "" : res.data.landNumber,
        distance: res.data.distance == null ? "" : res.data.distance,
        dob: res.data.dob == null ? "" : res.data.dob.split('T')[0],
        nationality: res.data.nationality,
        maritalStatus: res.data.maritalStatus,
        education: res.data.education == null ? 0 : parseInt(res.data.education),
        email: res.data.email == null ? "" : res.data.email,
        isActive: res.data.isActive,
        createdBy: res.data.createdBy,
        farmerTypeID: res.data.farmerTypeID == 0 ? 1 : res.data.farmerTypeID,
        secondaryMobile: res.data.secondaryMobile == null ? "" : res.data.secondaryMobile,
        numberofChildren: res.data.numberofChildren,
        repayingaloan: res.data.repayingaloan,
        sarubimareception: res.data.sarubimareception,
        extentID: res.data.extentID,
        extentValue: res.data.extentValue == null ? "" : res.data.extentValue,
        ownershipOfFarmingLandID: res.data.ownershipOfFarmingLandID,
        seasonalFarmer: res.data.seasonalFarmer,
        acknowledgementOne: true,
        acknowledgementTwo: true,
        acknowledgement: true,
        modeOfOperation: res.data.modeOfOperation == 0 ? 2 : res.data.modeOfOperation,
        titleID: res.data.titleID,
        otherTitle: res.data.otherTitle == null ? "" : res.data.otherTitle,
        businessName: res.data.businessName == null ? "" : res.data.businessName,
        brNumber: res.data.brNumber == null ? "" : res.data.brNumber,
        otherEducation: res.data.otherEducation == null ? "" : res.data.otherEducation,
        dsDivisionID: res.data.dsDivisionID,
        gnDivisionID: res.data.gnDivisionID,
        otherFestivalsCelebrated: res.data.otherFestivalsCelebrated == null ? "" : res.data.otherFestivalsCelebrated,
        isDormant: res.data.farmerActiveStatus
      }));
      setImageObject(res.data.imageURL)
      setFestivalName(res.data.festivalName)
      setLanguageName(res.data.languageName)
      setOwnershipOfFarmingLandList(res.data.farminglandName)
    }
  }

  async function GetFarmerFestivalByFarmerID(decrypted) {
    var res = await services.GetFarmerFestivalByFarmerID(decrypted);
    if (res.statusCode == "Success") {
      setFestivalName(res.data);
    }
  }

  async function GetFarmerLanguageByFarmerID(decrypted) {
    const res = await services.GetFarmerLanguageByFarmerID(decrypted);
    if (res.statusCode === "Success") {
      setLanguageName(res.data); setLanguageName(res.data);
    }
  }

  async function GetOwnershipOfFarmingLandByFarmerID(decrypted) {
    var res = await services.GetOwnershipOfFarmingLandByFarmerID(decrypted);
    if (res.statusCode == "Success") {
      setOwnershipOfFarmingLandList(res.data);
    }
  }

  function generateProvinceDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.provinceID} value={x.provinceID}>{x.provinceName}</MenuItem>)
      });
    }
    return items
  }

  function generateDistrictDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.districtID} value={x.districtID}>{x.districtName}</MenuItem>)
      });
    }
    return items
  }

  function generateCityDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.cityID} value={x.cityID}>{x.cityName}</MenuItem>)
      });
    }
    return items
  }

  function generateDsDivisionDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.dsDivisionID} value={x.dsDivisionID}>{x.dsDivisionName}</MenuItem>)
      });
    }
    return items
  }

  function generateGnDivisionDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.gnDivisionID} value={x.gnDivisionID}>{x.gnDivisionName}</MenuItem>)
      });
    }
    return items
  }

  async function getProvinceForDropdown() {
    const province = await services.GetProvinceForDropdown();
    setProvinceList(province);
  }

  async function getDistrictForDropdown() {
    const district = await services.GetDistrictForDropdown(formik.values.province);
    setDistrictList(district);
  }

  async function getCityForDropdown() {
    const city = await services.GetCityForDropdown(formik.values.province, formik.values.district);
    setCityList(city);
  }

  async function getDsDivisionsForDropdown() {
    if (formik.values.province != 0 && formik.values.district != 0 && formik.values.city != 0) {
      let model = {
        provinceID: parseInt(formik.values.province),
        districtID: parseInt(formik.values.district),
        cityID: parseInt(formik.values.city)
      }
      const dsDivision = await services.GetDsDivisionsForDropdown(model);
      setDsDivisionList(dsDivision);
    }
  }

  async function getGnDivisionsForDropdown() {
    if (formik.values.province != 0 && formik.values.district != 0 && formik.values.city != 0 && formik.values.dsDivisionID != 0) {
      let model = {
        provinceID: parseInt(formik.values.province),
        districtID: parseInt(formik.values.district),
        cityID: parseInt(formik.values.city),
        dsDivisionID: parseInt(formik.values.dsDivisionID)
      }
      const gnDivision = await services.GetGnDivisionsForDropdown(model);
      setGnDivisionList(gnDivision);
    }
  }

  async function getAllFestivalTypes() {
    const festival = await services.GetAllFestivalDetails();
    setFestivalList(festival);
  }

  async function getAllFarmerLanguageTypes() {
    const language = await services.GetAllFarmerLanguageTypes();
    setLanguageList(language);
  }

  async function GetAllOwnershipOfFarmingLandTypes() {
    const response = await services.GetAllOwnershipOfFarmingLandTypes();
    setOwnershipOfFarmingLandTypeList(response);
  }

  async function GetCollectionCenterByFarmerCollectionCenterID(decrypted1, decrypted) {
    var res = await services.GetCollectionCenterByFarmerCollectionCenterID(decrypted1, decrypted);
    if (res != null && decrypted1 !== 0) {
      setFormData((prevState) => ({
        ...prevState,
        supplyLocation: res.factoryName
      }))
      setIsDefault(res.isDefault);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetAllFactoriesByGroupID(groupFactory.groupID);
    if (res != null) {
      // setOperationEntityList(res);
      res.forEach(x => {
        if (x.factoryID == parseInt(TokenDecoder.getGroupFactoryToken().factory)) {
          setFormData((prevState) => ({
            ...prevState,
            supplyLocation: x.factoryName
          }))
        }
      });
    }
  }

  function validatePhoneNumber(phoneNumber) {
    try {
      const number = phoneNumberUtil.parseAndKeepRawInput(phoneNumber, 'LK');
      return phoneNumberUtil.isValidNumber(number);
    } catch (error) {
      return false;
    }
  };

  async function clearAll() {
    formik.resetForm();
    setDocumentData([]);
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const multiSelecthandleChange = (event) => {
    setFestivalName(event.target.value);
  };

  const OwnershipmultiSelecthandleChange = (event) => {
    setOwnershipOfFarmingLandList(event.target.value);
  };

  const multiSelecthandleChangeLanguage = (event) => {
    setLanguageName(event.target.value);
  };



  return (
    <>
      <LoadingComponent />
      <Page title="General Information |  FAPS">
        <Card>
          <Container>

            <FormikProvider value={formik}>
              <ToastContainer
                position="bottom-right"
                pauseOnHover
              />
              <Form autoComplete="off"
                disabled={!(formik.isValid && formik.dirty)}
                noValidate onSubmit={handleSubmit}
              >
                <Stack spacing={2} margin={3}>
                  <Typography variant="h6">
                    {(factoryType == 1 || factoryType == 3) ? "View Farmer" : pageProps.pageheadername}
                    {pageProps.isEditType == 2 ?
                      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" >
                        <Tooltip title="Family Details">
                          <IconButton
                            variant="outlined"
                            color="secondary"
                            onClick={handleNext}
                          >
                            <ArrowForwardIosOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                      :
                      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" >
                        <Tooltip title="Family Details">
                          <IconButton
                            variant="outlined"
                            color="secondary"
                            onClick={handleNext}
                            disabled={true}
                          >
                            <ArrowForwardIosOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Stack>}
                  </Typography>
                </Stack>
                <Stack spacing={2} margin={3} style={{ marginTop: '45px' }}>
                  <Stack direction={{ xs: 'column', sm: 'row' }}>
                    <Grid item md={4} xs={12}>
                      <Grid item md={12} xs={12} sx={{ marginLeft: 8 }}>
                        <Card style={{ borderRadius: '50%', height: 200, width: 200 }}>
                          {ImageObject == undefined ?
                            <CardMedia
                              component="img"
                              image="/static/mock-images/avatars/User-avatar.png"
                              alt="Paella dish"
                            /> :
                            <CardMedia
                              component="img"
                              image={`data:image/jpeg;base64,${ImageObject}`}
                            />}
                        </Card>
                        <Typography style={{ marginLeft: '50px' }} variant="h9">
                          {ImageObject == undefined ? "No Farmer Image" : "Farmer Image"}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item md={8} xs={12} >
                      <Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                          <Grid item md={6} xs={12}>
                            <TextField select
                              fullWidth
                              size="small"
                              label="Supplier Type *"
                              value={formik.values.farmerTypeID}
                              onChange={formik.handleChange}
                              {...getFieldProps('farmerTypeID')}
                              error={Boolean(touched.farmerTypeID && errors.farmerTypeID)}
                              helperText={touched.farmerTypeID && errors.farmerTypeID}
                              disabled={factoryType == 1 || factoryType == 3}
                              InputProps={{
                                readOnly: pageProps.isEditType == 3
                              }}
                            >
                              <MenuItem value={1}> Farmer</MenuItem>
                              <MenuItem value={2}> Collector</MenuItem>
                              <MenuItem value={3}> Farmer & Collector</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <TextField select
                              fullWidth
                              size="small"
                              label="Mode of Operation *"
                              value={formik.values.modeOfOperation}
                              onChange={formik.handleChange}
                              {...getFieldProps('modeOfOperation')}
                              error={Boolean(touched.modeOfOperation && errors.modeOfOperation)}
                              helperText={touched.modeOfOperation && errors.modeOfOperation}
                              disabled={factoryType == 1 || factoryType == 3}
                              InputProps={{
                                readOnly: pageProps.isEditType == 3
                              }}
                            >
                              <MenuItem value={2}> Individual</MenuItem>
                              <MenuItem value={1}> Business</MenuItem>
                            </TextField>
                          </Grid>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                          <Grid item md={6} xs={12} >
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                              <Grid item md={12} xs={12} >
                                <TextField
                                  fullWidth
                                  size="small"
                                  label={formik.values.modeOfOperation == 1 ? "Business Registration Number *" : "NIC Number *"}
                                  value={formik.values.nic}
                                  onChange={formik.handleChange}
                                  {...getFieldProps('nic')}
                                  error={Boolean(touched.nic && errors.nic)}
                                  helperText={touched.nic && errors.nic}
                                  disabled={factoryType == 1 || factoryType == 3}
                                  InputLabelProps={{ shrink: formik.values.nic != '' ? true : false }}
                                />
                              </Grid>
                              {pageProps.isEditType == 1 || pageProps.nicEdit == true ?
                                <Grid item md={2} xs={12} style={{ marginRight: '8px' }}>
                                  <Tooltip title="Search Farmer">
                                    <Button
                                      variant="outlined"
                                      color="secondary"
                                      style={{ height: '39px' }}
                                      onClick={() => GetFarmerDetailsByNIC()}
                                      startIcon={<SearchIcon />}
                                    >
                                    </Button>
                                  </Tooltip>
                                </Grid> : null}
                            </Stack>
                          </Grid>
                          <Grid item md={6} xs={12} >
                            <TextField
                              fullWidth
                              size="small"
                              label="Business Name *"
                              value={formik.values.businessName}
                              onChange={formik.handleChange}
                              {...getFieldProps('businessName')}
                              error={Boolean(touched.businessName && errors.businessName)}
                              helperText={touched.businessName && errors.businessName}
                              disabled={formik.values.modeOfOperation == 2 || formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                              InputProps={{
                                readOnly: pageProps.isEditType == 3
                              }}
                            />
                          </Grid>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                          <Grid item md={6} xs={12}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                              <Grid item md={6} xs={12}>
                                <TextField select
                                  fullWidth
                                  size="small"
                                  label="Title *"
                                  value={formik.values.titleID}
                                  onChange={formik.handleChange}
                                  {...getFieldProps('titleID')}
                                  error={Boolean(touched.titleID && errors.titleID)}
                                  helperText={touched.titleID && errors.titleID}
                                  disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.modeOfOperation == 1}
                                  InputProps={{
                                    readOnly: pageProps.isEditType == 3
                                  }}
                                >
                                  <MenuItem key={0} value={0}> Select Title</MenuItem>
                                  <MenuItem value={1}> Mr.</MenuItem>
                                  <MenuItem value={2}> Mrs.</MenuItem>
                                  <MenuItem value={3}> Ms.</MenuItem>
                                  <MenuItem value={4}> Prefer not to mention </MenuItem>
                                  <MenuItem value={5}> Other</MenuItem>
                                </TextField>
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  label="Other Title *"
                                  value={formik.values.otherTitle}
                                  onChange={formik.handleChange}
                                  {...getFieldProps('otherTitle')}
                                  error={Boolean(touched.otherTitle && errors.otherTitle)}
                                  helperText={touched.otherTitle && errors.otherTitle}
                                  disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.titleID != 5}
                                  InputProps={{
                                    readOnly: pageProps.isEditType == 3
                                  }}
                                />
                              </Grid>
                            </Stack>
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <Grid item md={12} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Preferred Name *"
                                value={formik.values.givenName}
                                onChange={formik.handleChange}
                                {...getFieldProps('givenName')}
                                error={Boolean(touched.givenName && errors.givenName)}
                                helperText={touched.givenName && errors.givenName}
                                disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                                InputProps={{
                                  readOnly: pageProps.isEditType == 3
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                          <Grid item md={6} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Full Name *"
                              value={formik.values.middleName}
                              onChange={formik.handleChange}
                              {...getFieldProps('middleName')}
                              error={Boolean(touched.middleName && errors.middleName)}
                              helperText={touched.middleName && errors.middleName}
                              disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.modeOfOperation == 1}
                              InputProps={{
                                readOnly: pageProps.isEditType == 3
                              }}
                            />
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Surname"
                              value={formik.values.firstName}
                              onChange={formik.handleChange}
                              {...getFieldProps('firstName')}
                              error={Boolean(touched.firstName && errors.firstName)}
                              helperText={touched.firstName && errors.firstName}
                              disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.modeOfOperation == 1}
                              InputProps={{
                                readOnly: pageProps.isEditType == 3
                              }}
                            />
                          </Grid>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Stack>
                </Stack>
                <Stack spacing={2} margin={3}>
                  <Stack direction={{ xs: 'column', sm: 'row' }} style={{}} spacing={2}>

                    <Grid item xs={4} sm={4} md={4}>
                      <TextField
                        fullWidth
                        id="outlined-name"
                        size="small"
                        type="date"
                        label="Date of Birth *"
                        value={formik.values.dob === '' ? new Date().toISOString().split('T')[0] : formik.values.dob}
                        onChange={formik.handleChange}
                        {...getFieldProps('dob')}
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(touched.dob && errors.dob)}
                        helperText={touched.dob && errors.dob}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.modeOfOperation == 1}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3,
                        }}
                        inputProps={{
                          max: new Date().toISOString().split('T')[0],
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <TextField
                        fullWidth
                        id="outlined-name"
                        size="small"
                        type="date"
                        label="Date of Registration *"
                        value={formik.values.joiningDate}
                        onChange={formik.handleChange}
                        {...getFieldProps('joiningDate')}
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(touched.joiningDate && errors.joiningDate)}
                        helperText={touched.joiningDate && errors.joiningDate}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3
                        }}
                        inputProps={{
                          max: new Date().toISOString().split('T')[0],
                        }}
                      />
                    </Grid>
                    {pageProps.isEditType != 1 ?
                      <Grid item xs={4} sm={4} md={4}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Supplier Code - Agrithmics"
                          value={formik.values.regNumber}
                          onChange={formik.handleChange}
                          {...getFieldProps('regNumber')}
                          error={Boolean(touched.regNumber && errors.regNumber)}
                          helperText={touched.regNumber && errors.regNumber}
                          disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || pageProps.isEditType == 3}
                          InputProps={{
                            readOnly: pageProps.isEditType == 3 || pageProps.isEditType == 2
                          }}
                        />
                      </Grid> : null}
                    {pageProps.isEditType == 1 ? <Grid item xs={4} sm={4} md={4}></Grid> : null}
                  </Stack>
                  <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                    <Grid item xs={4} sm={4} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Supplier Code - Navision"
                        value={formik.values.navisionNumber}
                        onChange={formik.handleChange}
                        {...getFieldProps('navisionNumber')}
                        error={Boolean(touched.navisionNumber && errors.navisionNumber)}
                        helperText={touched.navisionNumber && errors.navisionNumber}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || pageProps.isEditType == 3}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <FormControl variant='outlined' >
                        <InputLabel id="demo-mutiple-name-label">Language/s *</InputLabel>
                        <Select
                          fullWidth
                          variant='outlined'
                          labelId="demo-mutiple-checkbox-label"
                          label={"Language/s *"}
                          id="demo-mutiple-checkbox"
                          multiple
                          size="small"
                          value={language}
                          onChange={multiSelecthandleChangeLanguage}
                          renderValue={(selected) => selected.join(', ')}
                          MenuProps={MenuProps}
                          style={{ width: 340 }}
                          disabled={(language && pageProps.isEditType == 3 && pageProps.nicEdit) || factoryType == 1 || factoryType == 3 ? true : false}
                          InputProps={{
                            readOnly: pageProps.isEditType == 3
                          }}
                        >
                          {LanguageList.map((name) => (
                            <MenuItem key={name.farmerLanguageTypeName} value={name.farmerLanguageTypeName}>
                              <Checkbox checked={language.indexOf(name.farmerLanguageTypeName) > -1} />
                              <ListItemText primary={name.farmerLanguageTypeName} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        label="Gender *"
                        value={formik.values.gender}
                        onChange={formik.handleChange}
                        {...getFieldProps('gender')}
                        error={Boolean(touched.gender && errors.gender)}
                        helperText={touched.gender && errors.gender}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.modeOfOperation == 1}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3
                        }}
                      >
                        <MenuItem key={0} value={0}> Select Gender</MenuItem>
                        <MenuItem value={1}> Male</MenuItem>
                        <MenuItem value={2}> Female</MenuItem>
                        <MenuItem value={3}> Other</MenuItem>
                        <MenuItem value={4}> Prefer not to mention</MenuItem>
                      </TextField>
                    </Grid>
                  </Stack>
                  <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                    <Grid item xs={4} sm={4} md={4}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        label="Marital Status *"
                        value={formik.values.maritalStatus}
                        onChange={formik.handleChange}
                        {...getFieldProps('maritalStatus')}
                        error={Boolean(touched.maritalStatus && errors.maritalStatus)}
                        helperText={touched.maritalStatus && errors.maritalStatus}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.modeOfOperation == 1}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3
                        }}
                      >
                        <MenuItem key={0} value={0}> Select Marital Status</MenuItem>
                        <MenuItem value={1}> Married</MenuItem>
                        <MenuItem value={2}> Single</MenuItem>
                        <MenuItem value={3}> Other</MenuItem>
                        <MenuItem value={4}> Prefer not to mention</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <TextField select
                        fullWidth
                        size="small"
                        label="Highest Level of Education *"
                        value={formik.values.education}
                        onChange={formik.handleChange}
                        {...getFieldProps('education')}
                        error={Boolean(touched.education && errors.education)}
                        helperText={touched.education && errors.education}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.modeOfOperation == 1}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3
                        }}
                      >
                        <MenuItem key={0} value={0}> Select Education Type</MenuItem>
                        <MenuItem value={1}> No Formal Education</MenuItem>
                        <MenuItem value={2}> Grade 1 to 5</MenuItem>
                        <MenuItem value={3}> Upto Grade 8</MenuItem>
                        <MenuItem value={4}> O/Ls</MenuItem>
                        <MenuItem value={5}> A/Ls</MenuItem>
                        <MenuItem value={6}> Diploma</MenuItem>
                        <MenuItem value={7}> Graduate</MenuItem>
                        <MenuItem value={8}> Postgraduate</MenuItem>
                        <MenuItem value={9}> Doctorate</MenuItem>
                        <MenuItem value={10}> Other</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Other Highest Level of Education *"
                        value={formik.values.otherEducation}
                        onChange={formik.handleChange}
                        {...getFieldProps('otherEducation')}
                        error={Boolean(touched.otherEducation && errors.otherEducation)}
                        helperText={touched.otherEducation && errors.otherEducation}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.education != 10}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3
                        }}
                      />
                    </Grid>
                  </Stack>
                  <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                    <Grid item xs={4} sm={4} md={4}>
                      <Stack width={340}>
                        <FormControl variant='outlined' >
                          <InputLabel id="demo-mutiple-name-label">Festivals Celebrated</InputLabel>
                          <Select
                            fullWidth
                            variant='outlined'
                            labelId="demo-mutiple-checkbox-label"
                            label={"Festivals Celebrated"}
                            id="demo-mutiple-checkbox"
                            multiple
                            size="small"
                            value={festival}
                            onChange={multiSelecthandleChange}
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}
                            style={{ width: 340 }} s
                            disabled={(festival && pageProps.isEditType == 3 && pageProps.nicEdit) || factoryType == 1 || factoryType == 3 ? true : false}
                            InputProps={{
                              readOnly: pageProps.isEditType == 3
                            }}
                          >
                            {FestivalList.map((name) => (
                              <MenuItem key={name.festival} value={name.festival}>
                                <Checkbox checked={festival.indexOf(name.festival) > -1} />
                                <ListItemText primary={name.festival} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Other Festivals Celebrated *"
                        value={formik.values.otherFestivalsCelebrated}
                        onChange={formik.handleChange}
                        {...getFieldProps('otherFestivalsCelebrated')}
                        error={Boolean(touched.otherFestivalsCelebrated && errors.otherFestivalsCelebrated)}
                        helperText={touched.otherFestivalsCelebrated && errors.otherFestivalsCelebrated}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || otherFestival == false}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <TextField select
                        fullWidth
                        size="small"
                        label="Seasonal Supplier *"
                        value={formik.values.seasonalFarmer}
                        onChange={formik.handleChange}
                        {...getFieldProps('seasonalFarmer')}
                        error={Boolean(touched.seasonalFarmer && errors.seasonalFarmer)}
                        helperText={touched.seasonalFarmer && errors.seasonalFarmer}
                        disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                        InputProps={{
                          readOnly: pageProps.isEditType == 3
                        }}
                      >
                        <MenuItem key={0} value={0}>Select Seasonal Supplier</MenuItem>
                        <MenuItem value={1}>Yes</MenuItem>
                        <MenuItem value={2}> No</MenuItem>
                      </TextField>
                    </Grid>
                  </Stack>
                  <Divider variant="middle" />
                  <Typography variant="h8">
                    <b>{"Address"}</b>
                  </Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Province *"
                      name="province"
                      value={formik.values.province}
                      onChange={formik.handleChange}
                      {...getFieldProps('province')}
                      error={Boolean(touched.province && errors.province)}
                      helperText={touched.province && errors.province}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key={0} value={0}> Select Province</MenuItem>
                      {generateProvinceDropDownMenu(provinceList)}
                    </TextField>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="District *"
                      name="district"
                      value={formik.values.district}
                      onChange={formik.handleChange}
                      {...getFieldProps('district')}
                      error={Boolean(touched.district && errors.district)}
                      helperText={touched.district && errors.district}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key={0} value={0}> Select District</MenuItem>
                      {generateDistrictDropDownMenu(districtList)}
                    </TextField>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="City *"
                      name="city"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      {...getFieldProps('city')}
                      error={Boolean(touched.city && errors.city)}
                      helperText={touched.city && errors.city}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key={0} value={0} > Select City</MenuItem>
                      {generateCityDropDownMenu(cityList)}

                    </TextField>

                  </Stack>
                  <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="DS Division *"
                      name="dsDivisionID"
                      value={formik.values.dsDivisionID}
                      onChange={formik.handleChange}
                      {...getFieldProps('dsDivisionID')}
                      error={Boolean(touched.dsDivisionID && errors.dsDivisionID)}
                      helperText={touched.dsDivisionID && errors.dsDivisionID}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key={0} value={0} > Select DS Division</MenuItem>
                      {generateDsDivisionDropDownMenu(dsDivisionList)}

                    </TextField>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="GN Division *"
                      name="gnDivisionID"
                      value={formik.values.gnDivisionID}
                      onChange={formik.handleChange}
                      {...getFieldProps('gnDivisionID')}
                      error={Boolean(touched.gnDivisionID && errors.gnDivisionID)}
                      helperText={touched.gnDivisionID && errors.gnDivisionID}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    >
                      <MenuItem key={0} value={0} > Select GN Division</MenuItem>
                      {generateGnDivisionDropDownMenu(gnDivisionList)}

                    </TextField>
                    <TextField
                      fullWidth
                      size="small"
                      label="Address Line 1 *"
                      value={formik.values.address1}
                      onChange={formik.handleChange}
                      {...getFieldProps('address1')}
                      error={Boolean(touched.address1 && errors.address1)}
                      helperText={touched.address1 && errors.address1}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    />

                  </Stack>
                  <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Address Line 2 *"
                      value={formik.values.address2}
                      onChange={formik.handleChange}
                      {...getFieldProps('address2')}
                      error={Boolean(touched.address2 && errors.address2)}
                      helperText={touched.address2 && errors.address2}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Distance to Registered Collection Centre"
                      value={formik.values.distance}
                      onChange={formik.handleChange}
                      {...getFieldProps('distance')}
                      error={Boolean(touched.distance && errors.distance)}
                      helperText={touched.distance && errors.distance}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">Km</InputAdornment>,
                        step: 0.01,
                        readOnly: pageProps.isEditType == 3
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label={(IsDefault == 1) ? "Registered Collection Centre *" : "Assigned Collection Centre *"}
                      value={formik.values.supplyLocation}
                      onChange={formik.handleChange}
                      {...getFieldProps('supplyLocation')}
                      error={Boolean(touched.supplyLocation && errors.supplyLocation)}
                      helperText={touched.supplyLocation && errors.supplyLocation}
                      InputLabelProps={{ shrink: true }}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: true
                      }}
                    />
                  </Stack>
                  <Divider variant="middle" />
                  <Typography variant="h8">
                    <b>{"Contact Number/s"}</b>
                  </Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Primary Contact *"
                      value={formik.values.farmerMobile}
                      onChange={formik.handleChange}
                      {...getFieldProps('farmerMobile')}
                      error={Boolean(touched.farmerMobile && errors.farmerMobile)}
                      helperText={touched.farmerMobile && errors.farmerMobile}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Secondary Contact "
                      value={formik.values.secondaryMobile}
                      onChange={formik.handleChange}
                      {...getFieldProps('secondaryMobile')}
                      error={Boolean(touched.secondaryMobile && errors.secondaryMobile)}
                      helperText={touched.secondaryMobile && errors.secondaryMobile}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Email Address"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      {...getFieldProps('email')}
                      error={Boolean(touched.email && errors.email)}
                      helperText={touched.email && errors.email}
                      disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3}
                      InputProps={{
                        readOnly: pageProps.isEditType == 3
                      }}
                    />
                  </Stack>
                  <Divider variant="middle" />
                  {formik.values.nic == '' || factoryType == 3 ? null :
                    <Document
                      setDocumentData={setDocumentData}
                      farmerId={parseInt(pageProps.editingID)}
                      setDocumentCount={setDocumentCount}
                      factoryType={factoryType}
                      isEditType={pageProps.isEditType} // 3
                      nicEdit={pageProps.nicEdit} //true
                    />
                  }
                  <Stack>
                    <FormControlLabel
                      control={
                        <Switch
                          value={formik.values.acknowledgement}
                          checked={formik.values.acknowledgement}
                          {...getFieldProps('acknowledgement')}
                          onClick={formik.handleChange}
                          disabled={true}
                          color='secondary'
                          name="acknowledgement"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        />}
                      label="Acknowledgement"
                    />
                    {formik.values.acknowledgement == true || factoryType == 2 ?
                      <Stack>
                        <FormControlLabel
                          style={{ marginTop: '25px', marginLeft: '25px' }}
                          control={<Checkbox
                            value={formik.values.acknowledgementOne}
                            checked={formik.values.acknowledgementOne}
                            {...getFieldProps('acknowledgementOne')}
                            onClick={formik.handleChange}
                            defaultChecked
                            color="secondary"
                            name="acknowledgementOne"
                            disabled={true}
                          />}
                          label="The details provided are accurate." />
                        <FormControlLabel
                          style={{ marginLeft: '25px' }}
                          control={
                            <Checkbox
                              value={formik.values.acknowledgementTwo}
                              checked={formik.values.acknowledgementTwo}
                              {...getFieldProps('acknowledgementTwo')}
                              onClick={formik.handleChange}
                              defaultChecked
                              color="secondary"
                              name="acknowledgementTwo"
                              disabled={true}
                            />}
                          label="Consent given to Cargills to use data across the group to provide different services to the farmer." />
                      </Stack> : null}
                  </Stack >
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <FormControlLabel
                      control={
                        <Switch
                          value={formik.values.isActive}
                          checked={formik.values.isActive}
                          {...getFieldProps('isActive')}
                          onClick={formik.handleChange}
                          disabled={formik.values.nic == '' || factoryType == 1 || factoryType == 3 || formik.values.isDormant == false || permissionList.isDormentoFilterEnabled === true}
                          color='error'
                          name="isActive"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        />}
                      label="Is Active"
                    />
                    {permissionList.isDormentoFilterEnabled === true && (
                      <FormControlLabel
                        control={
                          <Switch
                            value={formik.values.isDormant}
                            checked={formik.values.isDormant}
                            {...getFieldProps('isDormant')}
                            onChange={(e) => {
                              const isDormantValue = e.target.checked;
                              formik.setFieldValue('isDormant', isDormantValue);
                              if (!isDormantValue) {
                                formik.setFieldValue('isActive', false);
                              }
                              if (isDormantValue) {
                                formik.setFieldValue('isActive', true);
                              }
                            }}
                            disabled={formik.values.nic === '' || factoryType === 3}
                            color='error'
                            name="isDormant"
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />
                        }
                        label="Not Dormant"
                      />
                    )}
                  </Stack>
                  {factoryType == 3 ? null :
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                      <LoadingButton
                        size="medium"
                        type="button"
                        variant="outlined"
                        color='error'
                        disabled={pageProps.isEditType == 1 ? false : true}
                        onClick={() => clearAll()}
                      >
                        Clear
                      </LoadingButton>
                      <LoadingButton
                        size="medium"
                        type="submit"
                        variant="contained"
                        color='secondary'
                      >
                        {pageProps.submitButtonName}
                      </LoadingButton>
                    </Stack>}
                </Stack>
              </Form>
            </FormikProvider>
          </Container>
        </Card>
      </Page >
    </>
  )
}